import React, { Component } from 'react';
import Slider from "react-slick";
import './style.css'
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import testimonialImg_1 from '../../images/testimonials/img-1.jpg';
import testimonialImg_2 from '../../images/testimonials/img-2.jpg';
import testimonialImg_3 from '../../images/testimonials/img-3.jpg';
import i18next from 'i18next';
import i18n from './../../i18n';
class Testimonial extends Component {
    render() {
        const settings = {
            dots: true,
            infinite: true,
            speed: 1200,
            slidesToShow: 2,
            arrows: false,
            margin:50,
            autoplay:true,
            slidesToScroll: 1,
            centerPadding: 30,
            focusOnSelect: false,
            responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                  }
                },
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 2,
                    initialSlide: 2
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
            ]
        };
        return (
            <div className="testimonial-area section-padding">
                <div className="container">
                <div className="section-title-1 text-center">
                    <h2 className="text-center">{i18n.t('particularity-title-label')}</h2>
                </div>
                    <div className="testimonial-active">
                    <Slider {...settings}>
                        <div className="my-testimonial particular-div">
                            <div className="inner-content">
                                <div className="content">
                                    {/* <div className="image-box"><img src={testimonialImg_1} alt="" /></div> */}
                                    <div className="quote-icon"><i className="fi flaticon-right-quote"></i></div>
                                    <h4>{i18n.t('particularity-sub-title-one-label')}</h4>
                                    <h5 className="designation">{i18n.t('particularity-secondary-title-one-label')}</h5>
                                    <div className="text justify-text">{i18n.t('particularity-sub-description-one-label')}</div>
                                </div>
                            </div>
                        </div>
                        <div className="my-testimonial particular-div">
                            <div className="inner-content">
                                <div className="content">
                                    {/* <div className="image-box"><img src={testimonialImg_1} alt="" /></div> */}
                                    <div className="quote-icon"><i className="fi flaticon-right-quote"></i></div>
                                    <h4>{i18n.t('particularity-sub-title-two-label')}</h4>
                                    <h5 className="designation">{i18n.t('particularity-secondary-title-two-label')}</h5>
                                    <div className="text justify-text">{i18n.t('particularity-sub-description-two-label')}</div>
                                </div>
                            </div>
                        </div>
                        <div className="my-testimonial particular-div">
                            <div className="inner-content">
                                <div className="content">
                                    {/* <div className="image-box"><img src={testimonialImg_1} alt="" /></div> */}
                                    <div className="quote-icon"><i className="fi flaticon-right-quote"></i></div>
                                    <h4>{i18n.t('particularity-sub-title-three-label')}</h4>
                                    <h5 className="designation">{i18n.t('particularity-secondary-title-three-label')}</h5>
                                    <div className="text justify-text">{i18n.t('particularity-sub-description-three-label')}</div>
                                </div>
                            </div>
                        </div>
                    </Slider>
                    </div>
                </div>
            </div>
           
        );
    }
}

export default Testimonial;            